var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.05239 0.659536C7.74535 0.384259 8.43173 0.307376 9.1507 0.424481C9.29069 0.447263 9.40833 0.541775 9.4606 0.673425L11.4842 5.76756C11.5379 5.90258 11.5146 6.05604 11.4233 6.16934C11.332 6.28264 11.1868 6.33818 11.0432 6.31479C10.4728 6.22187 9.92673 6.28349 9.37374 6.50316C8.65489 6.78872 8.01499 7.2947 7.33753 7.83037L7.33753 7.83037C6.64416 8.37864 5.92719 8.94557 5.09813 9.27491C4.62619 9.46239 4.15728 9.55763 3.67907 9.56247L6.0168 15.4473C6.09902 15.6543 5.99757 15.8889 5.79021 15.9713C5.58285 16.0536 5.34808 15.9526 5.26587 15.7456L2.68988 9.26101L0.666269 4.1669L0.482155 3.70342C0.399939 3.49646 0.501395 3.26188 0.708754 3.17951C0.916114 3.09714 1.15088 3.19815 1.23309 3.40512L1.32958 3.64801C1.82042 3.69364 2.2959 3.62231 2.77648 3.4314L2.77675 3.4313C3.49556 3.1457 4.13541 2.63977 4.81283 2.10414C5.50625 1.55585 6.2233 0.988887 7.05239 0.659536Z",
    fill: "#021317"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIcon);
export default __webpack_public_path__ + "static/media/flag_icon.9e89fbe37743d7204cca0faa89313e4d.svg";
export { ForwardRef as ReactComponent };